import type { ConsentPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function appendPatientConsent(data: ConsentPayloadDTO) {
  return patientRequestsTyped.append_patient_consent({ context: { showLoader: false }, data });
}
